import {
  BROKER_REQUEST_ITEM_STATUS_LABELS_RU,
  BROKER_REQUEST_STATUS_LABELS_RU,
  type BrokerRequestItemStatus,
  type BrokerRequestStatus,
} from '@crm/shared'
import { Badge } from '../../../shared/ui/Badge'

/** Статус запроса брокеру: «Ждём ответа» / «Ответ частично» / «Ответ получен». */
const REQUEST_COLORS: Record<BrokerRequestStatus, 'blue' | 'orange' | 'green'> = {
  SENT: 'blue',
  PARTIAL: 'orange',
  ANSWERED: 'green',
}

export function BrokerRequestStatusBadge({ status }: { status: BrokerRequestStatus }) {
  return <Badge color={REQUEST_COLORS[status]}>{BROKER_REQUEST_STATUS_LABELS_RU[status]}</Badge>
}

/** Статус строки запроса (партномера): ждём ответа / ответ получен. */
export function BrokerItemStatusBadge({ status }: { status: BrokerRequestItemStatus }) {
  return (
    <Badge color={status === 'ANSWERED' ? 'green' : 'blue'}>
      {BROKER_REQUEST_ITEM_STATUS_LABELS_RU[status]}
    </Badge>
  )
}
